/*
  Apipet — Rebuy enhancer (tema)
  Zamjena za "Ready JS" callbackove iz Rebuy admina (preneseno 25.9.2026.).
  Konfiguracija dolazi iz snippets/rebuy-config.liquid -> window.APRebuy.config.

  1. keepLast        — nasi stylesheetovi uvijek zadnji u kaskadi (Rebuy nakon loada ubacuje svoje stilove)
  2. domLabels       — prijevodi koje Rebuy nema kao language kljuc (prije: ready callback na 8 widgeta)
  3. bundleBuilder   — prijevodi modala i "Total Savings" na ApiBox stranicama (prije: setInterval 250 ms na 249806/252109/252120)
  4. gift            — logika poklona u kosarici (config giftWidgetIds; prije: ready callback na widgetu)
  4b. swapUpsell     — "veće pakiranje" u košarici: kad kupac doda ponuđeno veće pakiranje, manje se
                       makne iz košarice (config swapUpsell.widgetIds; prije: ready callback na widgetu)
  5. cart            — Smart Cart: oznake ispod naslova iz metafielda (pas/macka, problem kod
                       suplemenata), trust red ispod gumba, ispravna mnozina u "Ukupno (N proizvoda)"
  7. reorderSkin     — iste oznake na reorder landingu (prethodna narudzba + preporuke)
  6. widgetSkin      — svi Rebuy widgeti (config: ['*'] osim widgetExclude): iste oznake + badgevi
                       na slici (popust % odabrane varijante, "Novo" po tagu)
*/
(function () {
  'use strict';

  var CFG = (window.APRebuy && window.APRebuy.config) || {};
  var STYLE_IDS = ['ap-rebuy-widgets-css', 'ap-rebuy-cart-css'];

  /* ---------- 1. kaskada ---------- */
  function keepLast() {
    if (!document.body) { return; }
    var links = STYLE_IDS.map(function (id) { return document.getElementById(id); }).filter(Boolean);
    if (!links.length) { return; }
    /* seli se samo ako se iza nasih linkova pojavio TUDJI stylesheet (nase ne brojimo — inace ping-pong) */
    var foreign = false, n = links[0].nextElementSibling;
    while (n) {
      var css = n.tagName === 'STYLE' || (n.tagName === 'LINK' && n.rel === 'stylesheet');
      if (css && STYLE_IDS.indexOf(n.id) === -1) { foreign = true; break; }
      n = n.nextElementSibling;
    }
    var misplaced = links.some(function (l) { return l.parentNode !== document.body; });
    if (foreign || misplaced) { links.forEach(function (l) { document.body.appendChild(l); }); }
  }

  /* ---------- 2. prijevodi (DOM) ---------- */
  function applyDomLabels(root) {
    var labels = CFG.domLabels || [];
    root = root || document;
    labels.forEach(function (l) {
      root.querySelectorAll(l.selector).forEach(function (el) {
        if (el.textContent.trim() !== l.text) { el.textContent = l.text; }
      });
    });
  }

  /* ---------- 3. bundle builder (ApiBox) ---------- */
  function translateBundleBuilder() {
    var t = CFG.bundleBuilder || {};
    var map = t.texts || {};
    document.querySelectorAll('.rebuy-modal, .rebuy-quick-view').forEach(function (modal) {
      var title = modal.querySelector('.rebuy-modal__container-header');
      if (title && map[title.textContent.trim()]) { title.textContent = map[title.textContent.trim()]; }
      modal.querySelectorAll('button').forEach(function (b) {
        var k = b.textContent.trim();
        if (map[k]) { b.textContent = map[k]; }
      });
    });
    document.querySelectorAll('.rebuy-bundle-builder__total-savings-label').forEach(function (el) {
      var k = el.textContent.trim();
      if (map[k]) { el.textContent = map[k]; }
      el.style.marginRight = '5px';
    });
  }

  function hasBundleBuilder() {
    var ids = (CFG.bundleBuilder && CFG.bundleBuilder.widgetIds) || [];
    return ids.some(function (id) { return document.querySelector('[data-rebuy-id="' + id + '"]'); });
  }

  /* ---------- 4. sezonski poklon u kosarici ---------- */
  /* dok je u Rebuy adminu jos ukljucen ready callback, logiku radi on — tema se ne mijesa */
  function adminReady(w) {
    var cb = w && w.data && (w.data.callbacks || (w.data.config && w.data.config.callbacks));
    return !!(cb && cb.ready && cb.ready.enabled && cb.ready['function']);
  }
  var giftBound = {};
  function giftIds() {
    var ids = CFG.giftWidgetIds || (CFG.giftWidgetId ? [CFG.giftWidgetId] : []);
    return ids.map(String);
  }
  function giftSync(w) {
    if (!w || !window.Rebuy || !window.Rebuy.SmartCart || typeof window.Rebuy.SmartCart.items !== 'function') { return; }
    setTimeout(function () {
      var items = window.Rebuy.SmartCart.items() || [];
      var giftItem = items.find(function (item) {
        return item.properties && String(item.properties._widget_id) === String(w.id);
      });
      var matched = (w.data && w.data.metadata && w.data.metadata.matched_rules) || [];
      if (!giftItem && matched.length) { w.show(); } else { w.hide(); }
      if (matched.length === 0 && giftItem && window.Rebuy.Cart) { window.Rebuy.Cart.removeItem(giftItem); }
    }, 300);
  }
  function bindGift(widget) {
    if (!widget) { return; }
    var id = String(widget.id);
    if (giftIds().indexOf(id) === -1 || giftBound[id] || adminReady(widget)) { return; }
    giftBound[id] = true;
    giftSync(widget);
    document.addEventListener('rebuy:cart.change', function () { giftSync(widget); });
  }

  /* ---------- 4b. vece pakiranje u kosarici (swap) ----------
     Widget je cart cross-sell koji se ponasa kao upsell: pravilo "manje pakiranje u kosarici -> ponudi vece".
     Kad kupac doda ponudjeno vece pakiranje, manje (ulaz pravila) mice se iz kosarice. */
  var swapBound = {};
  function bindSwap(widget) {
    if (!widget) { return; }
    var id = String(widget.id);
    var ids = ((CFG.swapUpsell && CFG.swapUpsell.widgetIds) || []).map(String);
    if (ids.indexOf(id) === -1 || swapBound[id] || adminReady(widget)) { return; }
    swapBound[id] = true;
    document.addEventListener('rebuy.add', function (event) {
      var added = event && event.detail && event.detail.product && event.detail.product.id;
      var rules = (widget.data && widget.data.metadata && widget.data.metadata.matched_rules) || [];
      var rule = rules.find(function (r) {
        var o = r && r.output && r.output[0];
        return o && o.products && o.products[0] && o.products[0].product_id === added;
      });
      if (!rule) { return; }
      var from = rule.logic && rule.logic[0] && rule.logic[0].rules && rule.logic[0].rules[0];
      var removeId = from && from.products && from.products[0] && from.products[0].product_id;
      var items = (window.Rebuy && window.Rebuy.Cart && window.Rebuy.Cart.items && window.Rebuy.Cart.items()) || [];
      var item = items.find(function (i) { return i.product_id === removeId; });
      if (item) { setTimeout(function () { window.Rebuy.Cart.removeItem(item); }, 500); }
    });
    document.addEventListener('rebuy:cart.add', function () { setTimeout(function () { widget.show(); }, 500); });
  }

  /* ---------- 5. Smart Cart v2 ---------- */
  var CART = CFG.cart || {};

  /* metafieldi tipa list.single_line_text_field dolaze kao JSON string: "[\"Pas\",\"Mačka\"]" */
  function parseList(v) {
    if (!v) { return []; }
    if (Array.isArray(v)) { return v; }
    try { var p = JSON.parse(v); return Array.isArray(p) ? p : [String(p)]; } catch (e) { return [String(v)]; }
  }

  function cartMeta() {
    var map = {};
    var sc = window.Rebuy && window.Rebuy.SmartCart;
    var items = (sc && typeof sc.items === 'function' && sc.items()) || [];
    items.forEach(function (i) {
      var h = i.handle || (i.product && i.product.handle);
      var m = i.product && i.product.metafields && i.product.metafields.custom;
      if (h && m) { map[h] = m; }
    });
    return map;
  }

  /* m = product.metafields.custom; product (opcionalno) = za rezervu iz tagova "pas" / "mačka"
     kad widget nema ukljucene metafieldove */
  function tagsFor(m, product) {
    m = m || {};
    var out = [];
    var sp = CART.species || {};
    var za = parseList(m.tra_im_proizvode_za);
    if (!za.length && product && product.tags) {
      var tg = (typeof product.tags === 'string' ? product.tags.split(',') : product.tags)
        .map(function (t) { return String(t).trim().toLowerCase(); });
      var fb = CART.speciesFromTags || { 'pas': 'Pas', 'mačka': 'Mačka', 'macka': 'Mačka' };
      Object.keys(fb).forEach(function (t) {
        if (tg.indexOf(t) > -1 && za.indexOf(fb[t]) === -1) { za.push(fb[t]); }
      });
    }
    if (za.length > 1 && sp.both) { out.push({ text: sp.both }); }
    else if (za.length === 1 && sp[za[0]]) { out.push({ text: sp[za[0]] }); }

    var types = CART.problemTypes || [];
    var isType = parseList(m.tip_proizvoda).some(function (t) { return types.indexOf(t) > -1; });
    if (isType) {
      parseList(m.problemi_kod_ljubimca).slice(0, CART.maxProblems || 1).forEach(function (p) {
        var s = (CART.problems || {})[p];
        if (s) { out.push({ text: s, problem: true }); }
      });
    }
    return out;
  }

  /* oznake u zadanom elementu (idempotentno: ne dira DOM ako je sadrzaj isti) */
  function renderTags(host, tags) {
    var key = tags.map(function (t) { return t.text; }).join('|');
    var box = host.querySelector(':scope > .ap-cart-tags');
    if (!tags.length) { if (box) { box.parentNode.removeChild(box); } return; }
    if (box && box.getAttribute('data-key') === key) { return; }
    if (!box) { box = document.createElement('div'); box.className = 'ap-cart-tags'; host.appendChild(box); }
    box.setAttribute('data-key', key);
    box.innerHTML = '';
    tags.forEach(function (t) {
      var s = document.createElement('span');
      s.className = 'ap-cart-tag' + (t.problem ? ' ap-cart-tag--problem' : '');
      s.textContent = t.text;
      box.appendChild(s);
    });
  }

  function cartTags(root) {
    var map = cartMeta();
    root.querySelectorAll('li.rebuy-cart__flyout-item').forEach(function (li) {
      var info = li.querySelector('.rebuy-cart__flyout-item-info');
      if (!info) { return; }
      var handle = null;
      String(li.className).split(' ').some(function (c) {
        if (c.indexOf('product-') === 0 && map[c.slice(8)]) { handle = c.slice(8); return true; }
        return false;
      });
      renderTags(info, handle ? tagsFor(map[handle]) : []);
    });
  }

  /* ---------- badgevi na slici: popust % odabrane varijante + Novo (tag) ---------- */
  var BADGES = CFG.badges || {};

  function money(v) {
    if (v === null || v === undefined || v === '') { return null; }
    var n = parseFloat(String(v).replace(',', '.'));
    return isNaN(n) ? null : n;
  }
  function discountPercent(variant) {
    if (!variant) { return 0; }
    var price = money(variant.price), compare = money(variant.compare_at_price);
    if (price === null || compare === null || compare <= price) { return 0; }
    return Math.round(((compare - price) / compare) * 100);
  }
  function hasTag(product, list) {
    var tags = product.tags;
    if (!tags || !list || !list.length) { return false; }
    if (typeof tags === 'string') { tags = tags.split(','); }
    return tags.some(function (t) { return list.indexOf(String(t).trim().toLowerCase()) > -1; });
  }

  function renderBadges(block, product) {
    var media = block.querySelector('.rebuy-product-media');
    if (!media) { return; }
    var variant = product.selected_variant || (product.variants && product.variants[0]);
    var out = [];
    var pct = discountPercent(variant);
    if (BADGES.sale && pct >= (BADGES.minDiscount || 5)) {
      out.push({ mod: 'sale', text: String(BADGES.sale).replace('{percent}', pct) });
    }
    if (BADGES.new && hasTag(product, BADGES.newTags)) { out.push({ mod: 'new', text: BADGES.new }); }

    var key = out.map(function (b) { return b.text; }).join('|');
    var box = media.querySelector(':scope > .ap-badges');
    if (!out.length) { if (box) { box.parentNode.removeChild(box); } return; }
    if (box && box.getAttribute('data-key') === key) { return; }
    if (!box) { box = document.createElement('div'); box.className = 'ap-badges'; media.appendChild(box); }
    box.setAttribute('data-key', key);
    box.innerHTML = '';
    out.forEach(function (b) {
      var s = document.createElement('span');
      s.className = 'ap-badge ap-badge--' + b.mod;
      s.textContent = b.text;
      box.appendChild(s);
    });
  }

  /* widgeti (cross-sell u kosarici): oznake ispod naslova + badgevi na slici.
     Podaci iz widget.data.products (metafieldovi i tagovi vec dolaze u payloadu). */
  /* lista widgeta: ['*'] = svi osim CART.widgetExclude */
  function inList(list, id) {
    list = (list || []).map(String);
    if (list.indexOf('*') > -1) { return (CART.widgetExclude || []).map(String).indexOf(id) === -1; }
    return list.indexOf(id) > -1;
  }

  function widgetSkin() {
    ((window.Rebuy && window.Rebuy.widgets) || []).forEach(function (w) {
      var id = String(w.id);
      var doTags = inList(CART.widgetTagIds, id), doBadges = inList(BADGES.widgetIds, id);
      if (!doTags && !doBadges) { return; }
      var root = document.getElementById('rebuy-widget-' + id);
      var products = (w.data && w.data.products) || [];
      if (!root || !products.length) { return; }
      var blocks = root.querySelectorAll('.rebuy-product-block');
      products.forEach(function (p, i) {
        if (!p) { return; }
        var block = root.querySelector('.rebuy-product-block.product-id-' + p.id) || blocks[i];
        if (!block) { return; }
        if (doTags) {
          var info = block.querySelector('.rebuy-product-info');
          var m = p.metafields && p.metafields.custom;
          if (info) { renderTags(info, tagsFor(m, p)); }
        }
        if (doBadges) { renderBadges(block, p); }
      });
    });
  }

  function cartTrust(root) {
    var list = CART.trust || [];
    var btn = root.querySelector('.rebuy-cart__checkout-button');
    if (!list.length || !btn || !btn.parentNode || btn.parentNode.querySelector('.ap-cart-trust')) { return; }
    var ul = document.createElement('ul');
    ul.className = 'ap-cart-trust';
    list.forEach(function (t) { var li = document.createElement('li'); li.textContent = t; ul.appendChild(li); });
    btn.parentNode.insertBefore(ul, btn.nextSibling);
  }

  /* "Ukupno (3 proizvod)" -> "Ukupno (3 proizvoda)". Mijenja se nodeValue postojeceg tekstnog
     cvora (ne textContent elementa), da Vue i dalje azurira isti cvor kad se broj promijeni. */
  function cartPlural(root) {
    var w = CART.itemWord;
    var label = root.querySelector('.rebuy-cart__flyout-subtotal-label');
    if (!w || !label) { return; }
    var re = new RegExp('\\((\\d+)\\s+(' + w.join('|') + ')\\)');
    var tw = document.createTreeWalker(label, NodeFilter.SHOW_TEXT), n;
    while ((n = tw.nextNode())) {
      var v = n.nodeValue.replace(re, function (all, d) {
        d = parseInt(d, 10);
        var form;
        if (w.length >= 4) { /* slovenski: 1 izdelek, 2 izdelka, 3-4 izdelki, 5+ izdelkov */
          var h = d % 100;
          form = h === 1 ? w[0] : h === 2 ? w[1] : (h === 3 || h === 4) ? w[2] : w[3];
        } else {
          form = (d % 10 === 1 && d % 100 !== 11) ? w[0] : w[1];
        }
        return '(' + d + ' ' + form + ')';
      });
      if (v !== n.nodeValue) { n.nodeValue = v; }
    }
  }

  /* ---------- Kosarica: ukupna usteda uz subtotal (7.10.2026.) ----------
     Puna vrijednost = compare_at varijante (ako je veci od cijene) x kolicina; usteda = puna vrijednost
     minus ono sto se stvarno placa (popusti na stavci, gratis proizvodi) + popusti na razini kosarice.
     Postavke: config.cart.savings = { label, min (centi) }; savings: false gasi red. */
  var SAVINGS = CART.savings === false ? null : {
    label: (CART.savings && CART.savings.label) || 'Ukupno štediš',
    min: (CART.savings && typeof CART.savings.min === 'number') ? CART.savings.min : 200
  };

  /* compare_at_price stize u dva formata: REST string u eurima ("42.00") ili broj u centima (4200 —
     Rebuy ga tako prepise za pretplatne stavke). Prije (20.10.2026.) se broj u centima mnozio sa 100,
     pa je pretplata od 37,80 EUR pokazivala "štediš" 4.162,20 EUR.
     Zastita: compare_at veci od 10x cijene stavke smatra se neispravnim i ignorira se. */
  function toCents(v, ref) {
    if (v === null || v === undefined || v === '') { return 0; }
    var c;
    if (typeof v === 'number') { c = Math.round(v); }
    else {
      var n = parseFloat(String(v).replace(',', '.'));
      if (isNaN(n)) { return 0; }
      c = /[.,]/.test(String(v)) ? Math.round(n * 100) : Math.round(n);
    }
    if (ref > 0 && c > ref * 10) { return 0; }
    return c;
  }

  function cartSavingsCalc() {
    var RC = window.Rebuy && window.Rebuy.Cart, pay = 0, save = 0;
    try {
      (RC && RC.items ? RC.items() : []).forEach(function (i) {
        var qty = i.quantity || 0, unit = i.original_price || i.price || 0;
        var cmp = 0;
        /* pretplata: compare_at iz alokacije plana (centi) je cijena bez popusta pretplate */
        var spa = i.selling_plan_allocation;
        if (spa && spa.compare_at_price) { cmp = toCents(spa.compare_at_price, unit); }
        var vs = (i.product && i.product.variants) || [];
        for (var k = 0; !cmp && k < vs.length; k++) {
          if (String(vs[k].id) === String(i.variant_id)) {
            cmp = toCents(vs[k].compare_at_price, unit);
            break;
          }
        }
        if (cmp > unit) { unit = cmp; }
        var full = unit * qty;
        var fin = (typeof i.final_line_price === 'number') ? i.final_line_price : full;
        pay += fin;
        if (full > fin) { save += full - fin; }
      });
      var apps = (RC && RC.cart && RC.cart.cart_level_discount_applications) || [];
      for (var a = 0; a < apps.length; a++) {
        var amt = apps[a].total_allocated_amount || 0;
        save += amt; pay -= amt;
      }
    } catch (e) { return { was: 0, save: 0 }; }
    return { was: pay + save, save: save };
  }

  function cartMoney(c) {
    var RC = window.Rebuy && window.Rebuy.Cart;
    try {
      if (RC && RC.formatMoney) {
        var d = document.createElement('div');
        d.innerHTML = RC.formatMoney(c);
        if (d.textContent) { return d.textContent.trim(); }
      }
    } catch (e) {}
    var p = (c / 100).toFixed(2).split('.');
    return '€' + p[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + p[1];
  }

  function cartSavings(root) {
    if (!SAVINGS) { return; }
    var sub = root.querySelector('.rebuy-cart__flyout-subtotal');
    var label = sub && sub.querySelector('.rebuy-cart__flyout-subtotal-label');
    var amount = sub && sub.querySelector('.rebuy-cart__flyout-subtotal-amount');
    if (!label || !amount) { return; }
    var el = label.querySelector('.ap-cart-save');
    var was = amount.querySelector('.ap-cart-was');
    var s = cartSavingsCalc();
    if (s.save < SAVINGS.min) {
      if (el) { el.parentNode.removeChild(el); }
      if (was) { was.parentNode.removeChild(was); }
      sub.classList.remove('ap-has-save');
      return;
    }
    var txt = SAVINGS.label + ' ' + cartMoney(s.save), wtxt = cartMoney(s.was);
    if (!el) { el = document.createElement('span'); el.className = 'ap-cart-save'; label.appendChild(el); }
    if (el.textContent !== txt) { el.textContent = txt; }
    if (!was) { was = document.createElement('span'); was.className = 'ap-cart-was'; amount.appendChild(was); }
    if (was.textContent !== wtxt) { was.textContent = wtxt; }
    if (!sub.classList.contains('ap-has-save')) { sub.classList.add('ap-has-save'); }
  }

  function cartSkin() {
    var root = document.getElementById('rebuy-cart');
    if (!root || !root.querySelector('.rebuy-cart__flyout')) { return; }
    cartTags(root);
    cartTrust(root);
    cartPlural(root);
    cartSavings(root);
  }

  /* ---------- reorder landing (/apps/rebuy/reorder) ----------
     Stranica nije Rebuy widget, pa widgetSkin ne prolazi kroz nju. Podaci (s metafieldovima) su u
     Vue instanci #rebuy-reorder-landing-page: products (prethodna narudzba) i cross_sells.
     Oznake se dodaju na kraj bloka s naslovom; redoslijed (ispod naslova) rjesava CSS. */
  function reorderSkin() {
    var root = document.getElementById('rebuy-reorder-landing-page');
    var vm = root && root.__vue__;
    if (!vm) { return; }
    var pairs = [
      ['.rebuy-reorder-previous-item', '.rebuy-reorder-previous-item-top', vm.products || []],
      ['.rebuy-reorder-cross-sell-item', '.rebuy-reorder-cross-sell-item-info', vm.cross_sells || [], true]
    ];
    pairs.forEach(function (pr) {
      var list = pr[2];
      root.querySelectorAll(pr[0]).forEach(function (item, i) {
        var host = item.querySelector(pr[1]);
        var t = item.querySelector('.rebuy-reorder-title');
        if (!host || !t) { return; }
        var title = t.textContent.trim();
        var p = list.find(function (x) { return x && String(x.title).trim() === title; }) || list[i];
        if (!p) { return; }
        var m = p.metafields && p.metafields.custom;
        renderTags(host, tagsFor(m, p));
        if (pr[3]) { renderDesc(host, reorderDesc(p, m)); }
      });
    });
  }
  /* kratki opis za preporuke na reorderu: metafield opis_proizvoda_za_kolekcije, inace opis proizvoda */
  function reorderDesc(p, m) {
    var t = m && m.opis_proizvoda_za_kolekcije;
    if (!t) {
      var d = document.createElement('div');
      d.innerHTML = p.body_html || p.description || '';
      t = d.textContent || '';
    }
    t = String(t).replace(/\s+/g, ' ').trim();
    return t ? t.charAt(0).toUpperCase() + t.slice(1) : '';
  }
  function renderDesc(host, text) {
    var el = host.querySelector(':scope > .ap-reorder-desc');
    if (!text) { if (el) { el.parentNode.removeChild(el); } return; }
    if (el && el.textContent === text) { return; }
    if (!el) { el = document.createElement('p'); el.className = 'ap-reorder-desc'; host.appendChild(el); }
    el.textContent = text;
    el.title = text;
  }

  /* ---------- popupi: klizanje ponuda na desktopu ----------
     Niz ponuda je vodoravni overflow. Na mobitelu se klize prstom, a mis to ne zna:
     dodajemo strelice, kotacic misa (okomito -> vodoravno) i povlacenje misem. */
  var POPUP_IDS = ((CFG.popups && CFG.popups.widgetIds) || ['148792', '155617', '149753', '152630']).map(String);
  var POPUP_LABELS = (CFG.popups && CFG.popups.labels) || ['Prethodna ponuda', 'Sljedeća ponuda'];
  var ARROW = '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M9 5l7 7-7 7" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  function popupScroll() {
    POPUP_IDS.forEach(function (id) {
      var list = document.querySelector('#rebuy-widget-' + id + ' .splide__list');
      if (!list) { return; }
      var grid = list.closest('.rebuy-product-grid');
      if (!grid) { return; }
      var ctl = list.__apScroll;
      if (!ctl) {
        ctl = list.__apScroll = { busy: false };
        var step = function () {
          var b = list.querySelector('.rebuy-product-block');
          return b ? b.getBoundingClientRect().width + 14 : 224;
        };
        /* vlastita animacija: scrollBy({behavior:'smooth'}) na stranici ne radi (snap + skripte teme) */
        var go = function (dir) {
          var max = list.scrollWidth - list.clientWidth;
          var from = list.scrollLeft;
          var to = Math.max(0, Math.min(max, from + dir * step()));
          if (Math.abs(to - from) < 2) { return; }
          var t0 = null, dur = 320;
          list.style.scrollSnapType = 'none';
          var done = false;
          var finish = function () {
            if (done) { return; }
            done = true;
            list.scrollLeft = to;
            list.style.scrollSnapType = '';
            ctl.update();
          };
          var tick = function (ts) {
            if (done) { return; }
            if (t0 === null) { t0 = ts; }
            var k = Math.min(1, (ts - t0) / dur);
            list.scrollLeft = from + (to - from) * (1 - Math.pow(1 - k, 3));
            if (k < 1) { requestAnimationFrame(tick); } else { finish(); }
          };
          requestAnimationFrame(tick);
          setTimeout(finish, dur + 150); /* ako rAF ne tece (tab u pozadini) */
        };
        ctl.update = function () {
          var max = list.scrollWidth - list.clientWidth;
          grid.classList.toggle('ap-can-prev', list.scrollLeft > 4);
          grid.classList.toggle('ap-can-next', max > 4 && list.scrollLeft < max - 4);
        };
        ctl.make = function (dir) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'ap-pop-arrow ap-pop-arrow--' + (dir < 0 ? 'prev' : 'next');
          b.setAttribute('aria-label', dir < 0 ? POPUP_LABELS[0] : POPUP_LABELS[1]);
          b.innerHTML = ARROW;
          b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); go(dir); });
          return b;
        };
        list.addEventListener('scroll', ctl.update, { passive: true });
        window.addEventListener('resize', ctl.update);
        list.addEventListener('wheel', function (e) {
          if (Math.abs(e.deltaY) <= Math.abs(e.deltaX)) { return; } /* trackpad vodoravno radi sam */
          var max = list.scrollWidth - list.clientWidth;
          if (max <= 4) { return; }
          var dir = e.deltaY > 0 ? 1 : -1;
          if ((dir < 0 && list.scrollLeft <= 4) || (dir > 0 && list.scrollLeft >= max - 4)) { return; }
          e.preventDefault();
          if (ctl.busy) { return; }
          ctl.busy = true;
          go(dir);
          setTimeout(function () { ctl.busy = false; }, 380);
        }, { passive: false });
        var down = false, sx = 0, sl = 0, moved = false;
        list.addEventListener('mousedown', function (e) {
          if (e.button !== 0 || e.target.closest('select, button, input, label, option')) { return; }
          down = true; moved = false; sx = e.clientX; sl = list.scrollLeft;
        });
        window.addEventListener('mousemove', function (e) {
          if (!down) { return; }
          var dx = e.clientX - sx;
          if (!moved && Math.abs(dx) > 5) { moved = true; list.classList.add('ap-dragging'); }
          if (moved) { e.preventDefault(); list.scrollLeft = sl - dx; }
        });
        window.addEventListener('mouseup', function () {
          if (!down) { return; }
          down = false;
          if (moved) {
            list.classList.remove('ap-dragging');
            /* klik na kraju povlacenja ne smije otvoriti proizvod */
            list.addEventListener('click', function stop(ev) { ev.preventDefault(); ev.stopPropagation(); }, { capture: true, once: true });
            setTimeout(function () { list.dispatchEvent(new Event('scroll')); }, 0);
          }
        });
      }
      /* Vue moze ponovno iscrtati grid — strelice vracamo ako nestanu */
      if (!grid.querySelector(':scope > .ap-pop-arrow--prev')) { grid.appendChild(ctl.make(-1)); }
      if (!grid.querySelector(':scope > .ap-pop-arrow--next')) { grid.appendChild(ctl.make(1)); }
      grid.classList.add('ap-pop-scroll');
      ctl.update();
    });
  }

  /* ---------- ATC popupi: iznos ustede iz stvarnih cijena ----------
     Tekstovi ("Ušteda od 8 €", "štediš do 31 €") su upisani u pravila data sourcea 159374 / 166045.
     Da ne zastare kad se promijene cijene, broj ispred "€" u naslovu i opisu
     prepisujemo najvecom ustedom ponudenih varijanti (compare_at − cijena). */
  var SAVINGS_IDS = ((CFG.savings && CFG.savings.widgetIds) || ['148792', '155617']).map(String);
  var SAVE_RE = /(\d+(?:[.,]\d{1,2})?)(\s| )?€/g;
  function fmtEur(n) {
    var r = Math.round(n * 100) / 100;
    return (r % 1 === 0 ? String(r) : r.toFixed(2).replace('.', ',')) + ' €';
  }
  function maxSaving(products) {
    var best = 0;
    products.forEach(function (p) {
      if (!p) { return; }
      var vs = p.selected_variant ? [p.selected_variant] : (p.variants || []);
      vs.forEach(function (v) {
        var price = money(v && v.price), compare = money(v && v.compare_at_price);
        if (price !== null && compare !== null && compare - price > best) { best = compare - price; }
      });
    });
    return best;
  }
  function savingsSync() {
    ((window.Rebuy && window.Rebuy.widgets) || []).forEach(function (w) {
      var id = String(w.id);
      if (SAVINGS_IDS.indexOf(id) === -1) { return; }
      var root = document.getElementById('rebuy-widget-' + id);
      var products = (w.data && w.data.products) || [];
      if (!root || !products.length) { return; }
      var save = maxSaving(products);
      if (save < 0.5) { return; } /* bez stvarne ustede ostavljamo tekst iz Rebuyja */
      var txt = fmtEur(save);
      root.querySelectorAll('.primary-title, .description').forEach(function (el) {
        var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
        var n;
        while ((n = walker.nextNode())) {
          if (n.nodeValue.indexOf('€') === -1) { continue; }
          var nv = n.nodeValue.replace(SAVE_RE, txt);
          if (nv !== n.nodeValue) { n.nodeValue = nv; }
        }
      });
    });
  }

  /* ---------- sweep ---------- */
  var timer = null;
  function sweep() {
    keepLast();
    applyDomLabels(document);
    if (hasBundleBuilder()) { translateBundleBuilder(); }
    cartSkin();
    widgetSkin();
    reorderSkin();
    popupScroll();
    savingsSync();
  }
  function schedule() { clearTimeout(timer); timer = setTimeout(sweep, 120); }

  function onWidgetEvent(e) {
    var w = e && e.detail && e.detail.widget;
    if (w) { bindGift(w); bindSwap(w); }
    schedule();
  }

  ['rebuy.ready', 'rebuy.productsChange', 'rebuy.show', 'rebuy.refresh'].forEach(function (ev) {
    document.addEventListener(ev, onWidgetEvent);
  });
  ['rebuy.loaded', 'rebuy:smartcart.ready', 'rebuy:smartcart.show', 'rebuy:cart.change', 'rebuy:reorderLandingPage.ready'].forEach(function (ev) {
    document.addEventListener(ev, schedule);
  });

  /* promjena varijante u widgetu (select): drugi prolaz za spore Vue re-rendere */
  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('.rebuy-widget')) { schedule(); setTimeout(sweep, 400); }
  }, true);

  /* widgeti koji su bili spremni prije nego se ova skripta ucitala */
  function catchUp() {
    ((window.Rebuy && window.Rebuy.widgets) || []).forEach(function (w) { bindGift(w); bindSwap(w); });
    schedule();
  }

  /* Vue re-renderi (modal, promjena varijante) ne emitiraju event — observer */
  var mo = new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var t = muts[i].target;
      if (t && t.nodeType === 3) { t = t.parentElement; }
      if (t && t.closest && t.closest('.rebuy-widget, #rebuy-cart, .rebuy-modal, .rebuy-quick-view, #rebuy-reorder-landing-page')) { schedule(); return; }
      var added = muts[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var n = added[j];
        if (n.nodeType === 1 && (n.tagName === 'STYLE' || n.tagName === 'LINK' || (n.className && String(n.className).indexOf('rebuy') > -1))) { schedule(); return; }
      }
    }
  });

  function boot() {
    catchUp();
    mo.observe(document.body, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
})();
